import { PostTestSubmissionPresenter } from '@/presentation/presenters/judge/postTestSubmissionPresenter'
import { PostTestSubmissionViewModel } from '@/presentation/viewmodels/judge/postTestSubmissionViewModel'

export function usePostTestSubmissionPresenter(
  presenter: PostTestSubmissionPresenter = new PostTestSubmissionPresenter(new PostTestSubmissionViewModel())
) {
  return {
    judgeToken: presenter.judgeToken,
    isLoading: presenter.isLoading,
    error: presenter.error,
    postTestSubmission: presenter.postTestSubmission.bind(presenter)
  }
}
